/*
 * Markdown bodies. Semantic tokens only; the elements are the ones
 * Markdown.tsx can produce and no others.
 */

.markdown {
  overflow-wrap: anywhere;
  font-size: var(--text-base);
  color: var(--color-text-primary);
}

.markdown > * + * {
  margin-top: var(--space-3);
}

.markdown h3,
.markdown h4,
.markdown h5,
.markdown h6 {
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
}

.markdown h3 {
  font-size: var(--text-lg);
}

.markdown ul,
.markdown ol {
  padding-left: var(--space-6);
}

.markdown ul {
  list-style: disc;
}

.markdown ol {
  list-style: decimal;
}

.markdown li + li {
  margin-top: var(--space-1);
}

.markdown blockquote {
  padding-left: var(--space-3);
  border-left: var(--border-width-thick) solid var(--color-border-default);
  color: var(--color-text-secondary);
}

.markdown code {
  font-family: var(--font-family-mono);
  font-size: var(--text-sm);
  padding: 0 var(--space-1);
  border-radius: var(--radius-sm);
  background: var(--color-surface-sunken);
}

.markdown pre {
  padding: var(--space-3);
  border: var(--border-width-thin) solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: var(--color-surface-sunken);
  overflow-x: auto;
  white-space: pre;
}

.markdown pre code {
  padding: 0;
  background: none;
}

.markdown hr {
  border: 0;
  border-top: var(--border-width-thin) solid var(--color-border-default);
}

.markdown a {
  color: var(--color-text-link);
  text-decoration: underline;
}

.mention {
  font-weight: var(--font-weight-medium);
  color: var(--color-text-link);
}
